// External modules
import styled from '@emotion/styled';

// Internal modules
import {
  FONT_WEIGHT_NORMAL_PP,
  HEADER_COLOR,
  PAYPAL_OPEN_FONT,
  PP_SECONDARY_COLOR,
  PP_TERTIARY_COLOR,
  WARNING_COLOR_V2,
} from '@/styles';

export const NationalityContainer = styled.div<{ isFirstField?: boolean }>`
  margin: 16px 0 24px;
  order: ${({ isFirstField }) => (isFirstField ? -1 : 0)};
`;

export const NationalitySpan = styled.span`
  color: ${HEADER_COLOR};
  font-weight: ${FONT_WEIGHT_NORMAL_PP};
`;

export const Flex = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  min-height: 40px;
`;

export const EditButton = styled.button`
  align-items: center;
  background-color: ${PP_TERTIARY_COLOR};
  border: none;
  border-radius: 90px;
  cursor: pointer;
  display: flex;
  height: 40px;
  justify-content: center;
  margin-left: 6px;
  width: 40px;

  &:hover {
    background-color: ${WARNING_COLOR_V2};
  }

  &:focus,
  &:active,
  &:focus-within {
    border: none;
    box-shadow:
      0 0 0 3px ${PP_SECONDARY_COLOR} inset,
      0 0 0 6px rgb(16 114 235 / 16%);
    outline: none;
  }

  & :first-child {
    flex-shrink: 0;
  }
`;

export const SelectionMenuContainer = styled.div`
  .menuOption {
    p {
      /* The default font weight, size, and font are wrong using the PP react component */
      span {
        font-family: ${PAYPAL_OPEN_FONT};
        font-size: 18px;
        font-weight: 400;
      }
      /* This selects spans that include 'strong' in the class name */
      /* This ensures the selected element is bolded */
      span[class*='strong'] {
        font-weight: 500;
      }
    }
  }

  .selectionMenu {
    max-height: 400px;
    margin-top: 6px;
    right: 0;
  }
`;
